"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  // common
  LIST: "@@survey/list",
  FETCH: "@@survey/fetch",
  FETCH_PASSCODE: "@@survey/fetch_passcode",
  CREATE: "@@survey/create",
  UPDATE: "@@survey/update",
  LINKED_FUND: "@@survey/linked_fund",
  SAVE_LINKED_FUND: "@@survey/save_linked_fund",
  LOCK: "@@survey/lock",
  LOCK_BULK: "@@survey/lock_bulk",
  UNLOCK: "@@survey/unlock",
  UNLOCK_BULK: "@@survey/unlock_bulk",
  SOFT_DELETE: "@@survey/soft_delete",
  SOFT_DELETE_BULK: "@@survey/soft_delete_bulk",
  SUBMIT: "@@survey/submit",
  SUBMIT_BULK: "@@survey/submit_bulk",
  PAUSE: "@@survey/pause",
  PAUSE_BULK: "@@survey/pause_bulk",
  RESUME: "@@survey/resume",
  RESUME_BULK: "@@survey/resume_bulk",
  COPY_URL: "@@survey/copy_url",
  MAGIC_URL: "@@survey/magic_link",
  DOWNLOAD_ALL: "@@survey/download_all",
  DOWNLOAD_SURVEY_RESPONSE: "@@survey/download_survey_response",
  GET_SURVEY_PASSCODE: "@@survey/get_survey_passcode",
  // deleted data
  SOFT_DELETE_LIST: "@@survey/soft_delete_list",
  RESTORE: "@@survey/restore",
  RESTORE_BULK: "@@survey/restore_bulk",
  DELETE: "@@survey/delete",
  DELETE_BULK: "@@survey/delete_bulk",
  // Uploader
  PREFIGHT: "@@survey/prefight",
  IMPORT: "@@survey/import",
  ERROR_SHEET_DOWNLOAD: "@@survey/error_sheet_download",
  // analytics
  ANALYTICS_SAVE: "@@survey/analytics_save",
  ANALYTICS_GET: "@@survey/analytics_get",
  ANALYTICS_UPDATE: "@@survey/analytics_update",
  // configuration
  LIST_CONFIGURATION: "@@survey/list_configuration",
  FETCH_CONFIGURATION: "@@survey/fetch_configuration",
  // review and approve
  LIST_REVIEW_APPROVAL: "@@survey/list_review_approval",
  APPROVE: "@@survey/approve",
  APPROVE_BULK: "@@survey/approve-bulk",
  REVIEW_APPROVAL_RESET: "@@survey/review_approval_reset",
  // default
  RESET_AVOID: "@@survey/reset-avoid",
  RESET: "@@survey/reset",
  SUCCESS: "@@survey/success",
  ERROR: "@@survey/error"
};
exports.actionTypes = actionTypes;